// Numbers are stored in E.164 (+33428295236), which is what a `tel:` link and
// every provider need, but not how anyone reads a French number out loud. A
// French one is therefore SHOWN the way it is dialled at home -- 04 28 29 52 36
// -- and everything else is left exactly as stored: guessing a grouping for a
// country we know nothing about reads worse than the raw value.

// +33 followed by the 9 significant digits. A number in any other shape (a
// national 0X..., a partial capture) is left alone: it was never normalized, so
// there is nothing reliable to regroup.
const FRENCH_E164 = /^\+33([1-9]\d{8})$/

export function formatPhone(value: string): string {
  const match = FRENCH_E164.exec(value.trim())
  if (!match) return value
  // Back to the national form (leading 0), then the usual pairs.
  return `0${match[1]}`.replace(/\d{2}(?=\d)/g, "$& ")
}
